import { RootPaths } from "@src/appV2/App/paths";

export const EARNINGS_PATH = "account/earnings";

export const EARNINGS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${EARNINGS_PATH}`;
